/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AuctionCatalogPartStatsDto } from '../../models/auction-catalog-part-stats-dto';

export interface GetAuctionCatalogPartStats$Params {
  id: number;
  partId: number;
  'X-API-Version'?: string;
}

export function getAuctionCatalogPartStats(http: HttpClient, rootUrl: string, params: GetAuctionCatalogPartStats$Params, context?: HttpContext): Observable<StrictHttpResponse<AuctionCatalogPartStatsDto>> {
  const rb = new RequestBuilder(rootUrl, getAuctionCatalogPartStats.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
    rb.path('partId', params.partId, {});
    rb.header('X-API-Version', params['X-API-Version'], {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AuctionCatalogPartStatsDto>;
    })
  );
}

getAuctionCatalogPartStats.PATH = '/api/auction-catalogs/{id}/parts/{partId}/stats';
